import { z } from "zod";
import { actionPriorityEnum, actionStatusEnum } from "../db/schema";
import { avatarColorSchema } from "./avatar";
import { formTypeSchema } from "./common";

export const actionStatusSchema = z.enum(actionStatusEnum.enumValues);
export type ActionStatus = z.infer<typeof actionStatusSchema>;

export const actionPrioritySchema = z.enum(actionPriorityEnum.enumValues);
export type ActionPriority = z.infer<typeof actionPrioritySchema>;

export const actionResponseSchema = z.object({
  id: z.string(),
  viewId: z.string(),
  formId: z.string().optional(),
  formType: formTypeSchema.optional(),
  formViewId: z.string().optional(),
  safetyCheckId: z.string().nullable(),
  departmentId: z.string(),
  assignedUserId: z.string().nullable(),
  initiatedBy: z.string(),
  initiatedByUser: z.object({
    id: z.string(),
    name: z.string(),
    email: z.string(),
    color: avatarColorSchema,
  }),
  visitFormId: z.string().nullable(),
  drillFormId: z.string().nullable(),
  managementFormId: z.string().nullable(),
  investigationFormId: z.string().nullable(),
  observationFormId: z.string().nullable(),
  formFieldId: z.string().nullable(),
  title: z.string(),
  status: actionStatusSchema,
  priority: actionPrioritySchema,
  description: z.string().nullable(),
  actionType: z.string().nullable(),
  origin: z.string().nullable(),
  cause: z.string().nullable(),
  evaluationCriteria: z.string().nullable(),
  evaluationResult: z.string().nullable(),
  evaluationCost: z.number().nullable(),
  closingDate: z.string().datetime().nullable(),
  dueDate: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type ActionResponse = z.infer<typeof actionResponseSchema>;

export const actionFormSchema = z.object({
  id: z.string().min(1, "ID is required"),

  // THESE NEED TO COME TOGETHER
  formType: formTypeSchema.optional(),
  formId: z.string().optional(),

  origin: z.string().optional().nullable(),
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  openedAt: z.string().min(1, "Open date is required"),
  deadline: z.string().optional(),
  assignee: z.string().optional(), // Optional because it can be unassigned
  actionType: z.string().optional(),
  cause: z.string().optional(),
  status: actionStatusSchema,
  priority: actionPrioritySchema.optional(),
  initiatedBy: z.string().min(1, "Initiated by is required"),
  initiatedByUser: z
    .object({
      id: z.string(),
      name: z.string(),
      email: z.string(),
      color: avatarColorSchema,
    })
    .optional(),
  evaluationCriteria: z.string().optional(),
  evaluationResult: z.string().optional(),
  evaluationCost: z.number().optional(),
  closingDate: z.string().optional(),
});

// FIXME
// Upsert action schema
export const upsertActionSchema = actionFormSchema
  .partial()
  .extend({
    formViewId: z.string().optional(),

    // Optionaly fieldId
    fieldId: z.string().optional(),

    title: z.string().min(1, "Title is required"),
  })
  .omit({
    initiatedBy: true,
    initiatedByUser: true,
  });
